import {
  GET_LEAK_DETECTOR_INFOS_IN_PROGRESS,
  GET_LEAK_DETECTOR_INFOS_SUCCESS,
  GET_LEAK_DETECTOR_INFOS_FAIL,
  POST_LEAK_DETECTOR_IN_PROGRESS,
  POST_LEAK_DETECTOR_SUCCESS,
  POST_LEAK_DETECTOR_FAIL,
  PUT_LEAK_DETECTOR_IN_PROGRESS,
  PUT_LEAK_DETECTOR_SUCCESS,
  PUT_LEAK_DETECTOR_FAIL,
} from "../constants";

const initialState = {
  infos: undefined,
  saving: false,
  saved: false,
  errors: null,
};

/**
 * Leak detector reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function leakDetector(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_LEAK_DETECTOR_INFOS_IN_PROGRESS:
      return {
        ...state,
        infos: undefined,
      };

    case GET_LEAK_DETECTOR_INFOS_SUCCESS:
      return {
        ...state,
        infos: payload.infos,
      };

    case GET_LEAK_DETECTOR_INFOS_FAIL:
      return {
        ...state,
        infos: null,
      };

    case POST_LEAK_DETECTOR_IN_PROGRESS:
    case PUT_LEAK_DETECTOR_IN_PROGRESS:
      return {
        ...state,
        saving: true,
        saved: false,
        errors: null,
      };

    case POST_LEAK_DETECTOR_SUCCESS:
    case PUT_LEAK_DETECTOR_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
      };

    case POST_LEAK_DETECTOR_FAIL:
    case PUT_LEAK_DETECTOR_FAIL:
      return {
        ...state,
        saving: false,
        saved: false,
        errors: payload.violations,
      };

    default:
      return state;
  }
}
